import { Event, EventType } from "./Event";

import type { IAddOrderEvent } from "./types";

export class AddOrderEvent extends Event {
  constructor({
    orderId,
    paidAmount,
    orderAmount,
    items,
    customEventProperties,
  }: IAddOrderEvent) {
    super({
      event_type: EventType.order,
      event_properties: {
        order_id: orderId,
        paid_amount: paidAmount,
        order_amount: orderAmount,
        items,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
